import { siteConfig } from '../variables/config'
import HttpService from '../utils/Http.services';
import i18n from 'i18next';
import Cookies from 'universal-cookie';
import SocketServices from './socket.services';
import store from '../stores/storeConfig';
import { loremIpsum, name, surname, fullname, username, Avatar } from 'react-lorem-ipsum';
import { FormBuilderObjects, InputTypeToType } from '../variables/formBuilderData';
import moment from 'moment';
import * as actions from '../stores/actionsList';
import { nanoid } from 'nanoid';
import { EntitiesData } from '../variables/EntitiesData';
import { framesConfig } from '../variables/framesStatics';
import { e } from 'mathjs';

// import { initDB } from './db.service';

const cookies = new Cookies();


async function playSound(name) {

    let sound = '/sounds/' + name + '.mp3';
    let audioToPlay = new Audio(sound);

    try {
        await audioToPlay.play();
    } catch (err) {
        console.error("Cannot play sound", err);
        // Automatic playback failed. (safari)
        return;
    }
}

function isWhite(str) {

    if (!str) {
        return true
    }
    let whiteLimit = 240,
        r, g, b;

    r = parseInt("0x" + str.substring(1, 3));
    g = parseInt("0x" + str.substring(3, 5));
    b = parseInt("0x" + str.substring(5, 7));
    if (r < whiteLimit || b < whiteLimit || g < whiteLimit) {
        return false;
    }
    return true;
}

function conditionalWidth(rawWidth, media, config) {

    let output = media?.xs

    let defaults = {
        xl: 1200,
        lg: 992,
        md: 768,
        sm: 576,
        xs: 0
    }

    // let width = '100%'
    // let display = 'block'

    let minWidth = 0

    if (media) {
        for (const [key, value] of Object.entries(media)) {
            let thisWidth = 0
            if (Number(key)) {
                thisWidth = Number(key)
            } else {
                thisWidth = defaults[key] ?? 0
            }


            if (thisWidth >= minWidth && thisWidth <= rawWidth) {
                minWidth = thisWidth
                output = value
            }
        }
    }


    // console.log(output)

    return output
    // if (!width.includes('%') && !width.includes('px') && Number(width)) {
    //     if (Number(width) <= 12) {
    //         width = String(((Number(width) / 12) * 100) + '%')
    //     }
    // }

    // if (width == 'none') {
    //     display = 'none'
    //     width = 0
    // }



    // if (width != rawWidth) {
    //     this.setState({ width })
    // }
    // if (display != this.state.display) {
    //     this.setState({ display })
    // }
}

function chooseFontColor(rawcolor) {
    let color = "#fff"
    if (rawcolor) {
        if (isNaN(Number(rawcolor[1])) || isNaN(Number(rawcolor[3])) || isNaN(Number(rawcolor[5]))) {
            color = "#000"
        }
        if (!isNaN(Number(rawcolor[7])) && Number(rawcolor[7]) < 6) {
            color = "#000"
        }
    }


    return color
}



function initUser() {
    SocketServices.initSocket()
}




function translate(key, params) {
    return (
        i18n.t(key, params)
    )
}


function checkTextTranslation(text) {
    if (text && typeof text == 'string') {
        if (text.includes("{{lang}}")) {
            let newText = text
            newText = newText.replace('{{lang}}', '')
            newText = i18n.t(newText)
            return newText

        } else {
            return text
        }
    }
}


function checkTranslation(text) {
    if (text) {
        if (String(text).includes("{{lang}}")) {
            let newText = String(text)
            newText = newText.replace('{{lang}}', '')
            newText = i18n.t(newText)
            return newText

        } else {
            return text
        }
    }
}



function changeBodyDirection(language) {

    if (language === 'fa') {
        document.body.classList.remove('ltr')
        document.body.classList.add('rtl')
    } else {
        document.body.classList.remove('rtl')
        document.body.classList.add('ltr')
    }
}


function currentLng() {
    return i18n.language
}


function changeUrlWithLng(lng) {
    let pathname = window.location.pathname.split('/')
    for (let index = pathname.length - 1; index >= 0; index--) {
        if (pathname[index] === "") {
            pathname.splice(index, 1)
        }
    }


    if (lng === siteConfig.defaultLng && siteConfig.dontShowUrlForDefaultLng) {
        if (siteConfig.languages.indexOf(pathname[0]) !== -1) {
            // console.log(pathname.splice(0, 1).join('/'))
            pathname.splice(0, 1)
            pathname = pathname.join('/')
            window.location = '/' + pathname

        }
    } else {

        if (lng !== pathname[0]) {

            if (!pathname[0] || siteConfig.languages.indexOf(pathname[0]) !== -1) {
                pathname[0] = lng
            } else {
                pathname.splice(0, 0, lng)
            }
            window.location = "/" + pathname.join('/')
        }
    }
}


function defaultPathMaker() {
    if (siteConfig.forceUrl) {
        return siteConfig.dontShowUrlForDefaultLng ? (i18n.language === siteConfig.defaultLng ? '' : '/' + i18n.language) : '/' + i18n.language
    } else {
        return ''
    }
}

function pathMaker(path) {
    return defaultPathMaker() + path
}

function imageAddress(image, type, prefered, key) {
    // console.log(image)
    let imageInfo = {
        profile: { address: 'uploads/', defaultImg: '/images/profile-men-1.svg' },
        group: { address: 'uploads/', defaultImg: '/images/group-img.svg' },
        product: { address: 'uploads/', defaultImg: '/images/default.jpg' },
        applet: { address: 'uploads/', defaultImg: '/images/applet1.png' },
        // applet: { address: 'uploads/', defaultImg: '/images/c.png' },
        hub: { address: 'uploads/', defaultImg: '/images/profile-men-1.svg' },
        video: { address: 'uploads/', defaultImg: '/images/no-video.png' },
        videoCover: { address: 'uploads/videos/thumbnails/', defaultImg: '/images/no-video.png' },
        file: { address: 'uploads/', defaultImg: '/images/no-video.png' },
        messenger: { address: 'uploads/', defaultImg: '/assets/icons/portals/chat (2).png' },

    }

    key = key ?? 'address'
    // console.log('type group', image)
    let prefixAddress = 'uploads/'
    let defaultImg = ''
    if (imageInfo[type]) {
        prefixAddress = imageInfo[type].address
    }
    if (imageInfo[type] && imageInfo[type].defaultImg) {
        defaultImg = imageInfo[type].defaultImg
    } else {
        defaultImg = '/images/noimageavailable.png'
    }
    // console.log('type group', defaultImg)



    if (image && image != '') {

        let imageName = ''
        let myImage = Array.isArray(image) ? image[0] : image
        // console.log(image)

        if (prefered && myImage.sizes && myImage.sizes[prefered]) {
            // console.log("HERE")
            imageName = myImage.sizes[prefered][key]

        } else {
            if (typeof myImage === "object" && !Array.isArray(myImage)) {
                // console.log(image[key])
                imageName = myImage[key]
            } else {
                // console.log(myImage)
                imageName = myImage
            }
        }


        let final = siteConfig.assetsDomain + prefixAddress + imageName
        // console.log(final)

        if (Array.isArray(final)) {
            return final[0]
        }

        return final
    } else {
        return defaultImg
    }

}


function getToken() {
    let token = cookies.get('token')
    if (typeof token === "undefined") {
        token = null
    }
    return token
}
function getAnonymousToken() {
    let token = cookies.get('AN-token')
    if (typeof token === "undefined") {
        token = null
    }
    return token
}

function getUserInfo(cb) {
    // console.log("getUserInfo")
    // return
    HttpService.request("getUserInfo", null, (fetchResult, fetchError, status) => {
        // console.log("fetchResult")
        // console.log(fetchResult)
        if (fetchError) { if (cb) { cb(null, fetchError.message, status) }; return }
        if (cb) { cb(fetchResult, null, status) }
    })
}




function getOneThing(info, cb) {

    if (cb) {
        cb()
    }
    // HttpService.request("getOneThing", { id: info.id }, (fetchResult, fetchError, status) => {


    //     if (fetchError) { if (cb) { cb(null, fetchError.message, status) }; return }
    //     if (cb) { cb(fetchResult, null, status) }
    // })
}



function phoneStandardView(number) {
    let phone = number

    // console.log(phone)
    if (number) {
        if (number.includes('-')) {
            phone = number.substring(4, number.length)
        }
        let counter = 0
        while (number[counter] === "0") {
            counter++
        }
        let code = phone.substring(counter, 4)
        phone = phone.substring(4, number.length)
        // console.log(phone)
        phone = phone.replace(/\D*(\d{3})\D*(\d{3})\D*(\d{4})\D*/, '$1 $2 $3');
        // console.log(phone)

        phone = "+" + code + ' ' + phone

        return phone
    }
}

function formatPhoneNumber(phoneNumberString) {
    let cleaned = ('' + phoneNumberString).replace(/\D/g, '');
    console.log(cleaned)
    let match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    console.log(match)

    if (match) {
        return '(' + match[1] + ') ' + match[2] + '-' + match[3];
    }
    return null;
}



let numbers = { '0': '۰', '1': '۱', '2': '۲', '3': '۳', '4': '۴', '5': '۵', '6': '۶', '7': '۷', '8': '۸', '9': '۹' }

function converNumberToPersian(number) {
    if (number != null) {
        let numberArray = String(number).split('')
        numberArray.forEach((element, index) => {
            if (numbers[element]) {
                numberArray[index] = numbers[element]
            }
        });
        return numberArray.join('')

    }
}


function priceStandardView(priceRef) {
    if (priceRef != null) {

        let normalized = String(priceRef)
        let minus = false
        if (normalized.includes('-')) {
            minus = true
            normalized = normalized.replace('-', '')
        }

        let priceSides = String(normalized).split('.')

        let priceArray = String(priceSides[0]).split('')
        let price = ''
        // let j = 0
        for (let i = 0; i < priceArray.length; i++) {
            let element = priceArray[priceArray.length - 1 - i];
            // j++
            price = element + price
            // console.log(price)
            if ((i + 1) % 3 === 0 && i !== priceArray.length - 1) {
                price = ',' + price
            }
            // console.log(price)

        }
        if (price == null) {
            price = 0
        }
        if (priceSides[1]) {
            price = price + '.' + priceSides[1].substr(0, 2)

        }



        if (minus) {
            price = '-' + price
        }




        return price

    }
}



function setObject(data, key, value, append, index, dontRemoveNull) {
    // console.log('data, key, value',data, key, value)

    if (!data) data = {}

    if (data == '*') data = {}

    // if(key)



    if (key && key.includes('.')) {

        // if(key.includes("["))
        let pList = key.split('.');
        let newKey = [...pList]

        pList = pList[0]
        newKey.splice(0, 1)
        newKey = newKey.join('.')
        let newData
        if (pList.includes('[')) {
            let conditions = /\[(.*?)\]/.exec(pList)
            if (conditions) {
                let condition = conditions[1]
                let tempKey = pList.replace(conditions[0], '')
                pList = tempKey
                if (Array.isArray(data[tempKey])) {
                    let arrayIndex = extactArrayElementWithCondition(data[tempKey], condition)
                    if (arrayIndex != null) {
                        data[pList][arrayIndex] = setObject(data[pList][arrayIndex], newKey, value, append, index, dontRemoveNull)
                    }
                }
            }
        } else {

            // if (pList.includes('*')) {
            //     let keyValue = pList.split('*')
            //     newData = data[keyValue[1]][keyValue[0]]
            //     console.log(newData)
            // } else {
            // if (typeof data != 'object') {
            //     data = {}
            // }

            newData = data[pList]
            data[pList] = setObject(newData, newKey, value, append, index, dontRemoveNull)
            // }


        }

        return data

    } else {

        if (typeof key == 'string' && key.includes('~')) {
            // console.log("******")
            let valueIndex = key.split('~')
            // console.log(data)
            // console.log(valueIndex)
            // console.log(data[valueIndex[0]][valueIndex[1]])
            if (data[valueIndex[0]] && data[valueIndex[0]][valueIndex[1]]) {
                data[valueIndex[0]][valueIndex[1]] = value
            } else {
                data[key] = value
            }

        } else {

            if (append) {
                // console.log("APPLED")
                // console.log(key)
                if (append == 'object') {

                    for (const [nkey, nvalue] of Object.entries(value)) {
                        // console.log(nkey)
                        // console.log(nvalue)
                        if (!data[key]) {
                            data[key] = {}
                        }
                        data[key][nkey] = nvalue
                    }

                } else {

                    data[key] = data[key] ? data[key] : []
                    if (Array.isArray(value)) {
                        data[key] = [...data[key], ...value]
                    } else {


                        data[key] = [...data[key], value]
                    }
                }
            } else {
                if (index != null) {
                    if (!data[index]) {
                        data[index] = {}
                    }
                    data[index][key] = value
                    // if (!data[key]) {
                    //     data[key] = []
                    // }
                    // data[key][index] = value
                } else {
                    if (value == null) {
                        if (dontRemoveNull) {
                            data[key] = null
                        } else {
                            delete data[key]
                        }
                    } else {
                        // if (typeof data != 'object') {
                        //     data = {}
                        // }


                        data[key] = value
                    }
                }
                // console.log(key)
                // console.log(value)

            }
        }

        return data

    }

}


function extactArrayElementWithCondition(data, rawCondition) {
    let result
    let regex = /\*(.*?)\*/

    let condition = rawCondition.match(regex)[1]
    if (condition) {
        let sides = rawCondition.split(rawCondition.match(regex)[0])
        data.forEach((element, index) => {
            if (element[sides[0]] == sides[1]) {
                result = index
            }
        });
    }
    return result

}


// function setObject(data, key, value, append, index) {

//     if (!data) data = {}
//     if (key && key.includes('.')) {

//         // if(key.includes("["))
//         let pList = key.split('.');
//         let newKey = [...pList]
//         newKey.splice(0, 1)
//         newKey = newKey.join('.')
//         data[pList[0]] = setObject(data[pList[0]], newKey, value)
//         return data

//     } else {
//         if (append) {
//             data[key] = data[key] ? data[key] : []
//             if (Array.isArray(value)) {
//                 data[key] = [...data[key], ...value]
//             } else {
//                 data[key] = [...data[key], value]
//             }
//         } else {
//             if (index != null) {
//                 data[index][key] = value
//             } else {
//                 data[key] = value
//             }
//         }
//         return data
//     }

// }

function getObject(data, key, splitLevel, level, index) {

    if (data && key) {

        if (key.includes('.') && (splitLevel == null || level == null || splitLevel > (level ? level : 0))) {
            let pList = key.split('.');
            let newKey = [...pList]
            newKey.splice(0, 1).join('.')
            newKey = newKey.join('.')
            return getObject(data[pList[0]], newKey, splitLevel, level ? level + 1 : 1, index)

        } else {

            if (index != null && Array.isArray(data)) {
                if (data[index] != null) {
                    return data[index][key]
                } else {
                    return null
                }
                // return data[index][key]
            } else {
                return data[key]
            }
        }
    } else {
        return null
    }
}
// getPermissionObject(data, key, splitLevel, level, index){
//     if (data && key) {

//         if (key.includes('.') && (splitLevel == null || level == null || splitLevel > (level ? level : 0))) {
//             let pList = key.split('.');
//             let newKey = [...pList]
//             newKey.splice(0, 1).join('.')
//             newKey = newKey.join('.')
//             return getObject(data[pList[0]], newKey, splitLevel, level ? level + 1 : 1, index)

//         } else {
//             if (index != null && Array.isArray(data)) {
//                 if (data[index] != null) {
//                     return data[index][key]
//                 }
//                 else if (data[index] == '*z') {
//                     return true
//                 }
//                 else {
//                     return null
//                 }
//                 return data[index][key]
//             } else {
//                 return data[key]
//             }
//         }
//     } else {
//         return null
//     }
// }


function checkPermission(userPermissions, requiredPermission, nestedPermission, showLog, tryCount = 0) {
    // console.log('userPermissions, requiredPermission ',userPermissions, requiredPermission)
    // return true
    if (userPermissions) {
        // console.log('userPermissions', userPermissions)
        // console.log('requiredPermission', requiredPermission)
        // return true
        // if (!userPermissions) {
        //     return true
        //     userPermissions = {}
        // }
        // if ((requiredPermission.split('.') && requiredPermission.split('.')[0]) && !userPermissions.collection) {
        //     return true
        // }
        // let appletPermissions = userPermissions[applet]
        // console.log(requiredPermission)
        // for (let i = 0; i < userPermissions.length; i++) {

        // const userPermission = userPermissions[i].permissions;
        // if (showLog) {
        //     console.log(requiredPermission)
        //     console.log(appletPermissions)
        // }
        // console.log('appletPermissions', requiredPermission)
        // console.log('requiredPermission', { ...appletPermissions })
        let pass = getPermissionObject(userPermissions, requiredPermission)
        // console.log('passallowde requiredPermission', requiredPermission    )
        return pass.allowed
        // if (appletPermissions != '*' || (typeof appletPermissions[requiredPermission] == 'object' || appletPermissions[requiredPermission] == '*')) {
        //     if (appletPermissions[requiredPermission] == '*') {
        //         return true
        //     }
        //     else {
        //         return appletPermissions[requiredPermission][nestedPermission]
        //     }

        // }
        // else {
        //     if (appletPermissions == '*') {
        //         return true
        //     }
        //     else {
        //         return appletPermissions[requiredPermission]
        //     }
        // }
        // console.log(userPermission)
        // if (Array.isArray(requiredPermission)) {
        //     for (let j = 0; j < requiredPermission.length; j++) {
        //         const myRequiredPermission = requiredPermission[j];
        // console.log(myRequiredPermission)
        // console.log(userPermission)
        // let res = getPermissionObject(userPermissions, requiredPermission)
        // if (res?.allowed) {
        //     return true
        // }

        //     }
        // } else {
        //     let res = getPermissionObject(userPermission, requiredPermission)
        //     if (res?.allowed) {
        //         // console.log("ALLOWED")
        //         return true
        //     }
        // }
        // }

        // return false
    } else {
        return true
    }
    // else {
    //     if (tryCount <= 10) {
    //         tryCount += 1
    //         console.log('elsecheckPermission', tryCount)
    //         setTimeout(() => {
    //             checkPermission(requiredPermission, applet, nestedPermission, showLog, tryCount)
    //         }, 1000);
    //     }
    // }



}


// function checkPermission(userPermissions, requiredPermission, nestedPermission, showLog, tryCount = 0) {
//     console.log('requiredPermission ', requiredPermission)
//     // return true
//     if (userPermissions) {
//         console.log('userPermissions', userPermissions)
//         // return true
//         if (!userPermissions) {
//             return true
//             userPermissions = {}
//         }
//         if ((requiredPermission.split('.') && requiredPermission.split('.')[0]) && !userPermissions.collection) {
//             return true
//         }
//         // let appletPermissions = userPermissions[applet]
//         // console.log(requiredPermission)
//         // for (let i = 0; i < userPermissions.length; i++) {

//         // const userPermission = userPermissions[i].permissions;
//         // if (showLog) {
//         //     console.log(requiredPermission)
//         //     console.log(appletPermissions)
//         // }
//         // console.log('appletPermissions', requiredPermission)
//         // console.log('requiredPermission', { ...appletPermissions })
//         let pass = getPermissionObject(userPermissions, requiredPermission)
//         // console.log('passallowde', pass.allowed)
//         return pass.allowed
//         // if (appletPermissions != '*' || (typeof appletPermissions[requiredPermission] == 'object' || appletPermissions[requiredPermission] == '*')) {
//         //     if (appletPermissions[requiredPermission] == '*') {
//         //         return true
//         //     }
//         //     else {
//         //         return appletPermissions[requiredPermission][nestedPermission]
//         //     }

//         // }
//         // else {
//         //     if (appletPermissions == '*') {
//         //         return true
//         //     }
//         //     else {
//         //         return appletPermissions[requiredPermission]
//         //     }
//         // }
//         // console.log(userPermission)
//         // if (Array.isArray(requiredPermission)) {
//         //     for (let j = 0; j < requiredPermission.length; j++) {
//         //         const myRequiredPermission = requiredPermission[j];
//         // console.log(myRequiredPermission)
//         // console.log(userPermission)
//         // let res = getPermissionObject(userPermissions, requiredPermission)
//         // if (res?.allowed) {
//         //     return true
//         // }

//         //     }
//         // } else {
//         //     let res = getPermissionObject(userPermission, requiredPermission)
//         //     if (res?.allowed) {
//         //         // console.log("ALLOWED")
//         //         return true
//         //     }
//         // }
//         // }

//         // return false
//     }
//     // else {
//     //     if (tryCount <= 10) {
//     //         tryCount += 1
//     //         console.log('elsecheckPermission', tryCount)
//     //         setTimeout(() => {
//     //             checkPermission(requiredPermission, applet, nestedPermission, showLog, tryCount)
//     //         }, 1000);
//     //     }
//     // }



// }

function getPermissionObject(data, key, parentKey) {

    if (!parentKey) {
        parentKey = ''
    }
    // console.log("HERE", data, key)

    if (data && key) {

        if (key.includes('.')) {

            let pList = key.split('.');
            let newKey = [...pList]
            newKey.splice(0, 1).join('.')
            newKey = newKey.join('.')

            if (data == '*') {
                return { allowed: true, value: '*' }
            }
            else if (data[pList[0]] == '*') {
                parentKey = parentKey + (parentKey != "" ? '.' : '') + pList[0]

                return { allowed: true, parentLevel: true, parentKey: parentKey, value: '*' }
            } else {
                parentKey = parentKey + (parentKey != "" ? '.' : '') + pList[0]

                return getPermissionObject(data[pList[0]], newKey, parentKey)
            }

        } else {

            let value = data == '*' ? '*' : data[key]



            // if (value && typeof value == 'object' && !Array.isArray(value)) {
            //     if (Object.keys(value).length == 0) {
            //         value = null
            //     }
            // }

            return { allowed: (value == '*' || value) ? true : false, value: value }

        }
    } else {
        return { allowed: false }
    }
}


function capitalLetter(text) {
    if (text) {
        let words = text.split(' ')
        let newWords = []
        words.forEach((word, index) => {
            let newWord = word
            newWord = newWord.substr(0, 1).toUpperCase() + newWord.substr(1)
            newWords.push(newWord)
        });
        return newWords.join(' ')
    }
}

function chooseWallpaper(data) {
    // console.log(data)
    if ((data && data[0] && data[0].values && data[0].values.image)) {
        let image = Array.isArray(data[0].values.image) ? data[0].values.image[0] : data[0].values.image
        return siteConfig.assetsDomain + 'images/' + image.address
    }
    // return "/images/cover2.jpeg"
    // return "/images/cover.jpg"

}



function fetchWallpaper(page, options, cb) {
    HttpService.request('getValuesWithData', { applet: 'wallpapers', filter: { 'values.page': page } }, (fetchResult, fetchError) => {
        // console.log(fetchResult)
        if (fetchError) { cb(null, fetchError) }
        if (fetchResult && fetchResult.info) {
            // console.log(fetchResult)
            let wallpaper = Array.isArray(fetchResult.info) ? fetchResult.info[0] : fetchResult.info
            wallpaper = imageAddress(wallpaper.values.image)
            cb(wallpaper, fetchError)
        }
    })
}


function detectBrowser() {
    // Opera 8.0+
    if ((navigator.userAgent.indexOf("Opera") || navigator.userAgent.indexOf('OPR')) != -1) {
        return 'Opera'
    } else if (navigator.userAgent.indexOf("Chrome") != -1) {
        return 'Chrome'
    } else if (navigator.userAgent.indexOf("Safari") != -1) {
        return 'Safari'
    } else if (navigator.userAgent.indexOf("Firefox") != -1) {
        return 'Firefox'
    } else if ((navigator.userAgent.indexOf("MSIE") != -1) || (!!document.documentMode == true)) //IF IE > 10
    {
        return 'IE'
    } else {
        return ''
    }

}





function statusConvertor(status) {
    let statusTypes = {
        'C': { key: 'C', label: '{{lang}}Connected', color: '#35a130', backgroundColor: '#5dc25930' },
        'I': { key: 'I', label: '{{lang}}Invited', color: '#007aff', backgroundColor: '#007aff30' },
        'P': { key: 'P', label: '{{lang}}Pending', color: '#fff', backgroundColor: '#9ab' },
        'S': { key: 'S', label: '{{lang}}Self', color: '#fff', backgroundColor: '#000' },
        'V': { key: 'V', label: '{{lang}}Virtual', color: '#3387a3', backgroundColor: '#3387a330' },

    }
    if (status) {
        return statusTypes[status]
    } else {
        return {}
    }
}


function invoiceStatusConvertor(status) {

    let statusTypes = {
        "U": { title: "{{lang}}Unpaid", value: 'U', color: '#fff', background: 'linear-gradient(to right, #ee5050, #ee5050)' },
        'P': { title: "{{lang}}Paid", value: 'P', color: '#fff', background: 'linear-gradient(160deg, #80D0C7 0%, #80D0C7 100%)' },
        'PP': { title: "{{lang}}Partially Paid", value: 'PP', color: '#00CD74', background: 'linear-gradient(160deg, #D45BA1 0%, #A784E0 100%)' },
        'D': { title: "{{lang}}Draft", value: 'D', color: '#789', backgroundColor: 'linear-gradient(160deg, #D45BA1 0%, #A784E0 100%)' },
    }

    if (status) {
        return statusTypes[status]
    } else {
        return { title: "{{lang}}Paid", value: 'P', color: '#fff', background: 'linear-gradient(160deg, #80D0C7 0%, #80D0C7 100%)' }
    }
}




function sizeConvertor(size) {

    if (size != null) {

        let final = size
        let suffix = null
        suffix = 'B'
        if (final > 1000) {
            final = final / 1000
            suffix = 'KB'
        }
        if (final > 1000) {
            final = final / 1000
            suffix = 'MB'
        }

        if (final > 1000) {
            final = final / 1000
            suffix = 'GB'
        }


        return final.toFixed(1) + " " + suffix

    } else {
        return ''
    }
}



function nameShortener(text) {

    let final = text
    if (final.length > 16) {
        final = final.substr(0, 8) + '...' + final.substr(final.length - 8, final.length - 1)
    }


    return final
}


function msToHMS(secs) {
    var sec_num = parseInt(secs, 10)
    var hours = Math.floor(sec_num / 3600)
    var minutes = Math.floor(sec_num / 60) % 60
    var seconds = sec_num % 60

    return [hours, minutes, seconds]
        .map(v => v < 10 ? "0" + v : v)
        .filter((v, i) => v !== "00" || i > 0)
        .join(":")
    // alert( hours+":"+minutes+":"+seconds);
}





function checkDefaultTab(windowData, baseUrl, frames, width, cb) {
    // console.log('checkDefaultTab', windowData, baseUrl, frames)


    let def = ''
    let pageType = null
    let pageInfo = null
    let pathname = windowData?.path//window.location.pathname.split('/')
    let remainingPath = null


    let mindex = 1

    if (baseUrl) {

        // pathname.forEach((path, index) => {

        // if (path == (rootRef)) {
        mindex = baseUrl.length
        // }

        // });
    }
    // console.log(baseUrl)

    // console.log('ppppp',mindex)
    // console.log('pppppp',pathname)

    def = pathname[mindex]
    // console.log('pppppp',def)
    if (Array.isArray(def)) {
        def = def[0]
    }
    remainingPath = pathname.slice(mindex, pathname.length)

    if (!def) {
        def = ''
    }

    let pageIsValid = false

    let maxPathMatching = -1
    let maxPathVarMatching = -1

    if (frames) {
        Object.values(frames).forEach(page => {


            // console.log("page", page)

            let mainKey = page.key ?? page._id
            let slug = page.slug

            if (mainKey) {
                let pageKey = null
                // let pageKeyLength = 0
                let defaultPage = page.defaultPage
                if (conditionalWidth(width, { xs: true, sm: false })) {
                    defaultPage = false
                }

                // console.log("mainKey", mainKey)

                pageKey = mainKey.split('/')
                // pageKeyLength = pageKey.length
                // pageKey = pageKey[0]

                let tempMaxPathMatching = null
                let tempMaxPathVarMatching = null

                // console.log(pageKey)

                if (pageKey.length <= remainingPath.length) {

                    for (let i = 0; i < pageKey.length; i++) {
                        let key = pageKey[i];

                        let remaining = remainingPath[i];

                        // console.log(remaining, slug)
                        // console.log(remaining)

                        if (key == remaining || key == '[var]' || slug == remaining) {

                            // if (maxPathMatching <= i) {

                            tempMaxPathVarMatching = i

                            // console.log("tempMaxPathVarMatching")
                            // console.log(i)


                            if (key == remaining || slug == remaining) {
                                tempMaxPathMatching = i

                                // console.log("tempMaxPathMatching")

                            } else if (i == 0 && key == '[var]' && remaining != null) {

                                // console.log("HERE")
                                // console.log(i)

                                tempMaxPathMatching = i
                            }
                        }

                        // if (mainKey == '[var]/[var]') {
                        //     console.log("tempMaxPathMatching,", tempMaxPathMatching)
                        //     console.log("maxPathMatching, ", maxPathMatching)

                        // }

                    }


                    if (tempMaxPathMatching != null && tempMaxPathMatching >= maxPathMatching) {

                        if (tempMaxPathVarMatching > maxPathVarMatching) {



                            maxPathVarMatching = tempMaxPathVarMatching
                            maxPathMatching = tempMaxPathMatching

                            // console.log(tempMaxPathMatching)
                            // console.log(maxPathMatching)
                            // console.log(tempMaxPathVarMatching)
                            // console.log("page.pageType, ", page.pageType)


                            pageIsValid = true
                            pageType = page.pageType ?? page.type
                            pageInfo = page

                            def = mainKey
                            // console.log('pppppp',def)

                        }
                    } else {

                        // console.log("HERE")
                        // console.log(page)
                        // pageIsValid = true
                        // pageType = page.pageType
                        // pageInfo = page

                        // def = page.key

                    }
                }



            }


        });





        if (def === '') {
            pageType = ''
            pageIsValid = true
        }

        // console.log(def)
        // console.log('pppppppdef', pageType, def)
        cb(pageInfo, pageType, def)

    } else {
        // console.log('pppppppdef', def)
        cb(null, null, def)

    }
}

function userCheckDefaultTab(windowData, baseUrl, applet, frames, width, cb) {
    // console.log('checkDefaultTab', windowData, baseUrl, frames)


    let def = ''
    let pageType = null
    let pageInfo = null
    let pathname = windowData?.path//window.location.pathname.split('/')
    let remainingPath = null


    let mindex = 1

    if (baseUrl) {

        // pathname.forEach((path, index) => {

        // if (path == (rootRef)) {
        mindex = baseUrl.length
        // }

        // });
    }
    // console.log(baseUrl)

    // console.log('ppppp',mindex)
    // console.log('pppppp',pathname)

    def = pathname[mindex]
    // console.log('pppppp',def)
    if (Array.isArray(def)) {
        def = def[0]
    }
    remainingPath = pathname.slice(mindex, pathname.length)
    // console.log('pathname',pathname,mindex, pathname.length)

    if (!def) {
        def = ''
    }

    let pageIsValid = false

    let maxPathMatching = -1
    let maxPathVarMatching = -1

    if (frames) {
        Object.values(frames).forEach(page => {


            if (page.relatedFrame) {
                let pageKey = null
                // let pageKeyLength = 0
                let defaultPage = page.defaultPage
                if (conditionalWidth(width, { xs: true, sm: false })) {
                    defaultPage = false
                }

                pageKey = page.relatedFrame.split('/')
                // pageKeyLength = pageKey.length
                // pageKey = pageKey[0]

                let tempMaxPathMatching = null
                let tempMaxPathVarMatching = null

                // console.log(pageKey)
                // console.log(remainingPath)

                if (pageKey.length <= remainingPath.length) {

                    for (let i = 0; i < pageKey.length; i++) {
                        let key = pageKey[i];

                        let remaining = remainingPath[i];

                        // console.log(key)
                        // console.log(remaining)

                        if (key == remaining || key == '[var]') {

                            // if (maxPathMatching <= i) {

                            tempMaxPathVarMatching = i

                            // console.log("tempMaxPathVarMatching")
                            // console.log(i)


                            if (key == remaining) {
                                tempMaxPathMatching = i

                                // console.log("tempMaxPathMatching")

                            } else if (i == 0 && key == '[var]' && remaining != null) {

                                // console.log("HERE")
                                // console.log(i)

                                tempMaxPathMatching = i
                            }
                        }

                        // if (page.key == '[var]/[var]') {
                        //     console.log("tempMaxPathMatching,", tempMaxPathMatching)
                        //     console.log("maxPathMatching, ", maxPathMatching)

                        // }

                    }


                    if (tempMaxPathMatching != null && tempMaxPathMatching >= maxPathMatching) {

                        if (tempMaxPathVarMatching > maxPathVarMatching) {



                            maxPathVarMatching = tempMaxPathVarMatching
                            maxPathMatching = tempMaxPathMatching

                            // console.log(tempMaxPathMatching)
                            // console.log(maxPathMatching)
                            // console.log(tempMaxPathVarMatching)
                            // console.log("pageInfo, ", page)


                            pageIsValid = true
                            pageType = page.pageType
                            pageInfo = page

                            def = page.key
                            // console.log('pppppp',def)

                        }
                    } else {

                        // console.log("HERE")
                        // console.log(page)
                        // pageIsValid = true
                        // pageType = page.pageType
                        // pageInfo = page

                        // def = page.key

                    }
                } else {
                    let appletPage = applet.page?._id ?? applet.page
                    if (page._id == appletPage) {
                        pageIsValid = true
                        pageType = page.pageType
                        pageInfo = page

                        def = page.key
                    }

                }



            }


        });





        if (def === '') {
            pageType = ''
            pageIsValid = true
        }

        cb(pageInfo, pageType, def)

    } else {
        // console.log('pppppppdef', def)
        cb(null, null, def)

    }
}


function loremGenerator(type, options) {

    // console.log(type)
    const min = 1000;
    const max = 10000;

    // console.log(Avatar({}))
    switch (type) {
        case 'TextInput':
            return "{{lang}}Sample text input text"


        case 'TextAreaInput':
            return loremIpsum({ p: 1, avgWordsPerSentence: 10, avgSentencesPerParagraph: 2, })[0]


        case 'NumberInput':
            return Number((min + Math.random() * (max - min)).toFixed(0))


        case 'PriceInput':
            return Number((min + Math.random() * (max - min)).toFixed(0))


        case 'DateInput':
            return new Date()



        case 'GlobalUserInput':
            return { fullname: fullname({}), username: username({}) }


        case 'GlobalUserMultiInput':
            return [{ fullname: fullname({}), username: username({}) }, { fullname: fullname({}), username: username({}) }, { fullname: fullname({}), username: username({}) }]



        case 'ImageInput':
            let number = Math.round((Math.random() * (4)))
            return { address: `/samples/${number}.jpg`, local: true }


        default:
            return 'Other'
            break;
    }
}


function fieldTypeToIcon(type) {
    return FormBuilderObjects[type]?.icon
}


function getPermissionKey(key) {
    return key
}


function textVariableReplacer(data, content, fields, preLabel, returnRaw) {


    // console.log("textVariableReplacer",content)
    if (content && typeof content == 'string') {

        let output = content

        let reg = new RegExp('\{\{(.*?)\}\}', 'g')

        let matches = content.match(reg)

        if (matches) {
            for (let index = 0; index < matches.length; index++) {
                const match = matches[index];


                let key = match.replace(/{/g, '').replace(/}/g, '')


                // console.log(key)
                if (fields) {
                    for (let j = 0; j < fields.length; j++) {
                        const header = fields[j]

                        let label = header.information?.label
                        if (preLabel) {
                            label = preLabel + ' - ' + label
                        }

                        label = label.replace("{{lang}}", '')

                        if (key == header.information?.label || key == label || key == header.key) {


                            let value = getObject(data, header.key)
                            if (value == null) {
                                value = getObject(data, 'values.' + header.key)
                            }

                            if (!returnRaw) {
                                switch (header.type) {
                                    case "PriceInput":
                                        value = priceStandardView(value)
                                        break;

                                    case "NumberInput":
                                        value = priceStandardView(value)
                                        break;

                                    case "DateInput":
                                        let format = 'DD MMM YYYY'
                                        if (header.information?.showHour) {
                                            format = format + ' hh:mm'
                                        }
                                        if (moment(Number(value)).isValid()) {

                                        }
                                        value = moment(Number(value)).format(format)
                                        break;

                                    default:
                                        break;
                                }
                            }


                            if (typeof value == 'string') {
                                let nreg = new RegExp(match, 'g')
                                output = output.replace(nreg, value)
                            } else {
                                output = value
                            }

                        }


                    }
                }
            }
        }

        return output

    }

}






function paramsToValue(data, content, fields, preLabel, returnRaw) {

    // console.log("paramsToValue")
    // console.log(content)

    if (content && typeof content == 'string') {

        let output = content

        let reg = new RegExp('\{\{(.*?)\}\}', 'g')

        let matches = content.match(reg)

        if (matches) {
            for (let index = 0; index < matches.length; index++) {
                const match = matches[index];

                let key = match.replace(/{/g, '').replace(/}/g, '')


                // console.log(fields)
                // console.log(key)

                if (fields) {
                    for (let j = 0; j < fields.length; j++) {
                        const header = fields[j]

                        let label = header.information?.label
                        if (preLabel) {
                            label = preLabel + ' - ' + label
                        }

                        label = label.replace("{{lang}}", '')

                        // console.log(label)

                        if (key == header.information?.label || key == label || key == header.key) {

                            if (data) {
                                let value = getObject(data, header.key)
                                if (value == null) {
                                    value = getObject(data, 'values.' + header.key)
                                }

                                if (typeof value == 'string') {
                                    let nreg = new RegExp(match, 'g')
                                    output = output.replace(nreg, value)
                                } else {
                                    output = value
                                }
                            } else {
                                output = header.key
                            }

                        }


                    }
                }
            }
        } else {
            if (data) {
                output = getObject(data, content)
            } else {
                output = content
            }
        }

        return output

    }

}


function checkOperator(v1, operator, v2) {

    let mainV2
    if (v2) {
        try {
            mainV2 = JSON.parse(v2);
        } catch (e) {
        }
    }
    switch (operator) {
        case '==':
            return (v1 == v2)
        case '===':
            return (v1 === v2)
        case '!=':
            return (v1 != v2)
        case '!==':
            return (v1 !== v2)
        case '<':
            return (Number(v1) < Number(v2))
        case '<=':
            return (Number(v1) <= Number(v2))
        case '>':
            return (Number(v1) > Number(v2))
        case '>=':
            return (Number(v1) >= Number(v2))
        case '&&':
            return (v1 && v2)
        case '||':
            return (v1 || v2)

        case 'in':
            if (!Array.isArray(mainV2)) {
                return false
            }
            return mainV2.includes(v1)

        case 'is any of':

            if (Array.isArray(mainV2) && v1 != null) {
                return mainV2.includes(v1)
            } else {
                return
            }

        case 'is none of':
            if (Array.isArray(mainV2) && v1 != null) {
                return !mainV2.includes(v1)
            } else {
                return
            }

        case 'before':
            if (v1 && v2) {
                try {
                    // TO DO: check if already includes time
                    return moment(v1).isBefore(moment(v2).startOf('D'))
                } catch (e) { return }
            } else { return }

        case 'after':
            if (v1 && v2) {
                try {
                    // TO DO: check if already includes time
                    return moment(v1).isAfter(moment(v2).endOf('D'))
                } catch (e) { return }
            } else { return }

        default:
            return false
    }
}



function checkValueForFormVariables(value, variables, skipDataVariable) {
    let newValue = value

    if (typeof newValue == "string") {
        newValue = value.split(' ')

        for (let i = 0; i < newValue.length; i++) {
            const element = newValue[i]
            if (skipDataVariable) {
                // console.log(element, variables)
                newValue[i] = getValueOfFormVariable(element, variables, skipDataVariable)
            }
            if (!skipDataVariable && element.startsWith('@')) {
                // console.log(this.getValueOfVariable(element, variables))
                newValue[i] = getValueOfFormVariable(element, variables, skipDataVariable)
            }
        }
        if (newValue.length > 1) {
            newValue = newValue.join(' ')
        } else {
            newValue = newValue[0]
        }
    }

    return newValue

}

function getValueOfFormVariable(element, variables, skipDataVariable) {
    // console.log(element)

    if (!skipDataVariable) {
        let key = element.substring(1)
        key = key.split('.')
        let variableSource = key[0]
        key.splice(0, 1)
        key = key.join('.')

        return getObject(variables[variableSource], key)
    } else {
        return getObject(variables, element)
    }
}



function checkConditionGroup(group, variables, skipDataVariable, log) {

    if (group) {
        let result = false
        if (group.action && group.action == 'and') {
            result = true
        }
        // console.log(group)
        if (group.conditions && typeof group.conditions == 'object') {
            for (const [key, value] of Object.entries(group.conditions)) {

                if (checkOneCondition(value, variables, skipDataVariable, log) != result) {
                    return !result
                }
            }
        }

        return result
    } else {
        return false
    }
}




function checkOneCondition(condition, variables, skipDataVariable, log) {


    if (condition) {
        let action = condition.action
        if (action) {

            return checkConditionGroup(condition, variables, skipDataVariable, log)
        } else {

            // console.log("checkOneCondition", condition)
            // source operator target
            let source = checkValueForFormVariables((condition.source?.value ?? condition.source), variables, skipDataVariable)
            let operator = condition.operator?.value ?? condition.operator
            let target = skipDataVariable ? ((condition.target != null && typeof condition.target == 'object' && condition.target.hasOwnProperty("value")) ? condition.target?.value : condition.target) : checkValueForFormVariables(((condition.target != null && typeof condition.target == 'object' && condition.target.hasOwnProperty("value")) ? condition.target?.value : condition.target), variables, skipDataVariable)

            // console.log(condition.target?.value)
            // console.log(source, operator, target)

            // if (target != null || operator == 'is empty' && operator == 'is not empty') {
            // console.log(checkOperator((Array.isArray(source) ? JSON.stringify(source) : source), operator, (Array.isArray(target) ? JSON.stringify(target) : target)))

            return checkOperator((Array.isArray(source) ? JSON.stringify(source) : source), operator, (Array.isArray(target) ? JSON.stringify(target) : target))
            // } else {
            //     return false
            // }

        }
    }
}



function addToCard(applet, hub, product, action, count, variants, additionals, cb) {

    let body = {}
    body.count = count
    body.action = action
    body.product = product
    body.applet = applet
    body.hub = hub

    body.variants = variants
    body.additionals = additionals

    HttpService.request('updateItemCount', body, (fetchResult, fetchError, fetchStatus) => {
console.log('updateItemCount', fetchResult, fetchError)
        if (fetchError) {
            store.dispatch(actions.addNotif({ type: 'error', title: '{{lang}}Update failed', description: fetchError?.message }))

            cb(null, true)

            return
        }

        cb(true)

        if (fetchResult?.cart) {

            store.dispatch(actions.setCart(fetchResult?.cart))

        }

    })

}




function groupBy(data, headers, keys, keyIndex = 0, cb) {

    // console.log("groupBy")

    if (keys && keys.length > 0) {

        let group = {}

        if (data) {

            let key = keys[keyIndex]
            let header
            let othersOption


            if (headers) {
                headers.forEach(element => {
                    if (key == element.key) {
                        header = element
                    }
                })
            }


            if (Array.isArray(header.options)) {
                for (let index = 0; index < header.options.length; index++) {
                    const option = header.options[index];
                    if (option.key == '*') {
                        othersOption = option
                    }

                }
            }



            if (Array.isArray(data)) {
                data.forEach(element => {
                    let value = getObject(element, key)
                    if (Array.isArray(value)) {
                        value = value[value.length - 1]
                    }
                    value = String(value)
                    // console.log("VALUE",value)
                    let label

                    if (Array.isArray(header.options)) {
                        header.options.forEach(option => {
                            if (option.key && option.key.toLowerCase() == value.toLowerCase()) {
                                label = option.label
                            }
                        });
                    }


                    if (!label && othersOption) {
                        label = othersOption.label
                        value = othersOption.key
                    }



                    if (!group[value]) {

                        group[value] = { children: [], label, header, id: nanoid() }
                    }
                    group[value].children.push(element)
                });
            }
            // else {
            //     // let value = String(getObject(data, key))
            //     // if (!group[value]) {
            //     //     group[value] = []
            //     // }
            //     // group[value].push(data)
            // }
            // });
            if (keyIndex != keys.length - 1) {
                // return group
                // } else {
                for (let [groupKey, groupValues] of Object.entries(group)) {

                    let label

                    if (Array.isArray(header.options)) {
                        header.options.forEach(option => {
                            if (option.key && option.key.toLowerCase() == groupKey.toLowerCase()) {
                                label = option.label
                            }
                        });
                    }


                    if (!label && othersOption) {
                        label = othersOption.label
                        groupKey = othersOption.key
                    }



                    group[groupKey] = { header, id: nanoid(), label, children: groupBy(groupValues.children, headers, keys, keyIndex + 1, cb) }
                }
            }
            // else{}
            if (keyIndex == 0) {
                cb(group)
            }
            return group
        }
    }
}



function timeToTimeAgo(date, showTime) {

    let timestamp = moment(date).valueOf()
    let now = new Date().valueOf()
    let diff = now - timestamp
    let startOfDay = moment(now).startOf('day').valueOf()

    let result = moment(date).format('MM/DD/YY')



    if (diff < 7 * 24 * 60 * 60 * 1000) {

        if (timestamp >= startOfDay) {
            result = moment(date).format('HH:mm')
        } else if (diff < 24 * 60 * 60 * 1000) {
            result = translate("Yesterday")
        } else {
            let day = moment(date).day()
            let week = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
            result = week[day]
            if (showTime) {
                result = result + ' ' + moment(date).format('HH:mm')
            }
        }
    }

    return result


}





function paramToStandardOption(params, rawValue, variableIndicatior) {

    let value = rawValue
    if (value && typeof value == 'string') {

        if (variableIndicatior) {
            if (variableIndicatior == '{{') {
                if (/\{\{(.*?)\}\}/.test(value)) {
                    value = value.replace('{{', '').replace('}}', '')
                }
            }
        }



        let splitted = value.split('.')

        let paramsList = params
        if (params && typeof paramsList == 'object') {
            paramsList = Object.values(params)
        }

        let path = []

        let finalValue = getValueOfParam(paramsList, splitted, splitted[0], 0, path)

        // console.log(path)
        return [finalValue, path]
    } else {

        return [null, null]

    }

}

function getValueOfParam(params, splitted, myKey, index, path) {


    if (index <= splitted.length) {

        let found
        let nested

        for (let i = 0; i < params.length; i++) {
            const element = params[i];
            let key = element._id ?? element.key

            if (key == myKey) {

                found = element

            } else if (key.startsWith(myKey + '.')) {

                nested = true

            }

        }


        if (found || nested) {


            if (nested && !found) {

                return getValueOfParam(params, splitted, (myKey + '.' + splitted[(index + 1)]), (index + 1), path)

            } else {

                let list = found.list ?? found.structure

                if (!list && found) {

                    let dataType = InputTypeToType[(found.dataType ?? found.type)] ?? (found.dataType ?? found.type)

                    // console.log(dataType)
                    let entity = EntitiesData[dataType]
                    if (entity) {
                        list = Object.values(entity)
                    }

                    if (found.permissions) {
                        list = Object.values(found.permissions)
                    }
                }

                // console.log(index, (splitted.length - 1), found, list)
                path.push(found)

                if (index == (splitted.length - 1)) {
                    return found
                } else if (Array.isArray(list)) {
                    return getValueOfParam(list, splitted, splitted[(index + 1)], (index + 1), path)
                }

            }

        }

    }

}



function getAppletsAndhubsFromFramesList(frames, cb) {

    let hubs = []
    let applets = []

    if (Array.isArray(frames)) {
        // console.log('this.props.framessl',this.props.frames)
        frames.forEach(frame => {

            let frameInfo = framesConfig[frame.type]

            if (frameInfo) {
                Object.entries(frameInfo)?.map(([key, value]) => {
                    frame[key] = value
                    if (typeof value == 'string' && value.startsWith('{{')) {
                        let baseValue = value.replace(/{/g, '').replace(/}/g, '')
                        frame[key] = frame[baseValue]
                    }
                })
            }
            if (frame.type == 'collection' && Array.isArray(frame.fields)) {
                frame.fields.forEach(field => {
                    if (!field.key.includes("values.")) {
                        field.key = "values." + field.key
                    }
                })
            }

            let found = false
            hubs.forEach(hub => {
                if ((frame?.hub?._id ?? frame?.hub) == (hub._id ?? hub)) {
                    found = true
                }
            });
            if (!found && frame?.hub) {
                hubs.push(frame?.hub)
            }

            found = false
            applets.forEach(applet => {
                if (frame.applet?._id == applet._id) {
                    found = true
                }
            });
            if (!found) {
                applets.push(frame.applet)
            }
        })
    }

    cb(hubs, applets)

}



const createMessengerInfo = (messenger, myId) => {


    let name
    let image = messenger.image
    let allRefs = []
    let myValidRefs = []
    let info = {}
    // let adminInfo = {}
    let userInfo = {}


    // console.log("messenger", messenger)
    // if (messenger?.type == 'support1') {

    //     // console.log("SUPPORT")
    //     let isAdmin
    //     messenger.interactiveUsers.forEach(element => {
    //         // console.log('element---', element)
    //         // console.log('myId---', myId)
    //         if (element.hub?._id == myId && element.admin) {
    //             isAdmin = true
    //         }
    //     })
    //     if (isAdmin) {
    //         messenger.users?.forEach(element => {
    //             // console.log('element.hub', element.hub)
    //             if (element.hub && element.hub?._id != myId) {
    //                 name = element.hub.fullname
    //             }
    //         })
    //     } else {
    //         name = messenger.name
    //     }
    // } else if (messenger.type == 'group') {
    //     name = messenger.name

    // } else {

    // console.log("messenger.type", messenger.type, myId)


    if (Array.isArray(messenger.interactiveUsers)) {
        messenger.interactiveUsers.forEach(element => {
            if (element.hub?._id == myId) {

                // console.log("HERE 1")

                let refs = element.refs


                if (Array.isArray(refs) && Array.isArray(messenger.users)) {
                    // let ref = refs[0]?.hub
                    // let finalUser 

                    for (let j = 0; j < refs.length; j++) {
                        const ref = refs[j];
                        let frameId = ref.frame?._id ?? ref.frame
                        let isAdmin = false


                        const refHub = ref.hub;

                        if (messenger.type == 'group') {

                            name = messenger.name

                        } else {

                            // console.log("HERE 2")


                            for (let r = 0; r < messenger.users.length; r++) {
                                const mUser = messenger.users[r].hub;

                                // console.log(mUser, refHub)

                                if ((mUser?._id ?? mUser) != (refHub?._id ?? refHub)) {//&& ((mUser?._id ?? mUser) != myId)

                                    // console.log("HERE 3", mUser)

                                    name = mUser?.fullname
                                    image = mUser?.image

                                    if (ref.admin) {
                                        // isAdmin = true

                                        // console.log("ADMIN", ref)
                                        // for (let r2 = 0; r2 < messenger.users.length; r2++) {
                                        //     const mUser2 = messenger.users[r2].hub;

                                        //     if ((mUser2?._id ?? mUser2) != (refHub?._id ?? refHub)) {

                                        if (!userInfo[frameId]) {
                                            userInfo[frameId] = {}
                                        }
                                        userInfo[frameId] = { name: ref.hub?.fullname, image: ref.hub?.image, frame: ref.frame, applet: ref.applet }

                                        // console.log("ADMIN", userInfo[frameId])


                                        // }
                                        // }


                                    }

                                }
                            }
                        }

                        if ((myId) != (refHub?._id ?? refHub)) {

                            allRefs.push(refs[j])

                        }


                        messenger["**frame"] = ref.frame

                        messenger["**applet"] = ref.applet

                        if (!info[frameId]) {
                            info[frameId] = {}
                        }
                        info[frameId] = { name, image, frame: ref.frame, applet: ref.applet }


                        // if (messenger.type == 'support' && isAdmin) {

                        //     if (!adminInfo[frameId]) {
                        //         adminInfo[frameId] = {}
                        //     }
                        //     adminInfo[frameId] = { name, image, frame: ref.frame, applet: ref.applet }


                        // }



                    }


                }


                if (element.hub && element.hub._id && element.hub._id == myId) {
                    myValidRefs = element.refs
                }

            }
        })
    }
    // }

    // console.log("messenger.interactiveUsers",messenger.interactiveUsers)

    // console.log("messenger.frames",messenger.frames)

    // if (Array.isArray(messenger.frames)) {
    //     messenger.frames.forEach(frame => {
    //         // console.log("frame", frame.hub, myId)
    //         if ((frame.hub?._id ?? frame.hub) == myId) {

    //             // console.log("ff", frame)

    //             messenger["**frame"] = frame.frame

    //         }
    //     })
    // }

    // console.log("messenger.applets",messenger.applets)


    // if (Array.isArray(messenger.applets)) {
    //     messenger.applets.forEach(applet => {
    //         // console.log("applet",myId, applet)
    //         if ((applet.hub?._id ?? applet.hub) == myId) {

    //             messenger["**applet"] = applet.applet

    //         }
    //     })
    // }

    // console.log("INFO", info)
    // console.log("ADMININFO", adminInfo)

    messenger["**name"] = name
    messenger["**image"] = image
    messenger["**refs"] = allRefs
    messenger["**myValidRefs"] = myValidRefs

    messenger["**info"] = info
    messenger["**userInfo"] = userInfo

    // messenger["**TopicName"] = "{{lang}}Default"


    return messenger


}




export { paramToStandardOption, createMessengerInfo, timeToTimeAgo, getAppletsAndhubsFromFramesList, groupBy, isWhite, addToCard, checkConditionGroup, checkOneCondition, checkValueForFormVariables, getValueOfFormVariable, checkOperator, paramsToValue, textVariableReplacer, fieldTypeToIcon, loremGenerator, msToHMS, checkPermission, checkDefaultTab, userCheckDefaultTab, nameShortener, sizeConvertor, playSound, conditionalWidth, translate, initUser, invoiceStatusConvertor, statusConvertor, getPermissionObject, detectBrowser, getOneThing, changeBodyDirection, changeUrlWithLng, currentLng, checkTextTranslation, checkTranslation, pathMaker, imageAddress, getToken, getAnonymousToken, getUserInfo, phoneStandardView, getObject, setObject, capitalLetter, chooseFontColor, chooseWallpaper, priceStandardView, converNumberToPersian, fetchWallpaper, getPermissionKey }
